/* eslint-disable no-loop-func */
import { LevelsPrApi, PiezometryApi, SeuilsApi } from '../../api';
import { createGlobalStyle } from 'styled-components';
import { Subject } from 'rxjs';
import { dateFormatedForRequest } from './ecpDetailHelper';
import { checkLimits } from './PrDoDetailHelper';
import React from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import DropDownList from 'saur_ui_library/src/Molecules/DropDownList/DropDownList';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import RadioList from 'saur_ui_library/src/Molecules/RadioList/RadioList';
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import { v4 as uuidv4 } from 'uuid';
import { TabProps } from '../../Interface';
import { FormControl, MenuItem, Select, Typography, CircularProgress } from '@mui/material';


export const warningMessageCss = {
  color: 'red',
  fontSize: '14px',
}
const subject2 = new Subject();
// graphes
export const dataService2 = {
  setError: (d: boolean) => subject2.next(d),
  getError: () => subject2.asObservable(),
};

export const getPiezoMeasures = async (piezoCodes: string, startDate: any, endDate: any) => {
  let piezoList: any[] = [];
  try {
    const response = await PiezometryApi.getMeasures(piezoCodes, startDate, endDate);
    if (response.status === 200 && response.data.length > 0) {
      // get piezo data and avoid piezo with no measures
      return response.data.reduce((acc, item) => {
        const measures = item.measures.map((d) => ({
          time: d.date,
          value: parseFloat(d.value),
        }));
        if (measures.length > 0) {
          acc.push({ code: item.code, measures });
        }
        return acc;
      }, []);
    } else {
      return [];
    }
  } catch (error) {
    return piezoList;
  }
};

export const getAllMeasures = async (Api: {
  getAllMeasure: Function;
  getPluvio: Function;
}, type: string, code: any, startDate: any, endDate: any) => {
  let doTemps: any[] = [],
      doNombre: any[] = [],
      doVolume: any[] = [],
      prTemps: any[] = [],
      prNombre: any[] = [],
      prVolume: any[] = [],
      mrVolume: any = [],
      mrNiveau: any = [],
      mrTaux: any = [],
      pluvioList: any[] = [];
  try {
    const responseAllMeasures = Api.getAllMeasure(code, startDate, endDate);
    const responsePluvio = Api.getPluvio(code, startDate, endDate);
    const [getMeasures, getPluvio] = await Promise.allSettled([responseAllMeasures, type === 'do' ? responsePluvio : Promise.resolve(null)]);

    if (getMeasures.status === 'fulfilled') {
      const provideData = type === 'do' ? getMeasures.value.data : getMeasures.value.data.measures;
      const isPrOrMrInstallCode = String(code ?? '').includes('PR') || String(code ?? '').includes('MR');
      const normalizedVariableName = (item: any) =>
        String(item?.variableName ?? '')
          .toUpperCase()
          .replace(/[\s_-]+/g, '');
      const isPrTimeMeasure = (item: any) => {
        const variableName = normalizedVariableName(item);
        return item.variableType === 'TFCT' || variableName.startsWith('TPOMPE');
      };
      const isPrNumberMeasure = (item: any) => {
        const variableName = normalizedVariableName(item);
        return item.variableType === 'NBDEMPR' || variableName.startsWith('NPOMPE');
      };
      const isPrVolumeMeasure = (item: any) => {
        const variableName = normalizedVariableName(item);
        return item.variableType === 'VPOMPR' || variableName.startsWith('VPOMPE');
      };

      provideData.forEach((item) => {
        //DO
        if (
          item.variableType === 'NBDEVDO' &&
          code.includes('DO') &&
          type === 'do'
        ) {
          doNombre = item;
        } else if (
          item.variableType === 'TDEVDO' &&
          code.includes('DO') &&
          type === 'do'
        ) {
          doTemps = item;
        } else if (
          item.variableType === 'VDEVDO' &&
          code.includes('DO') &&
          type === 'do'
        ) {
          doVolume = item;
        }

        //TP
        else if (
          (item.variableType === 'TDEBTP' ||
            item.variableType === 'TDEBPR' ||
            isPrTimeMeasure(item)) &&
          isPrOrMrInstallCode &&
          type === 'do'
        ) {
          prTemps.push(item);
        } else if (
          (item.variableType === 'NDEBTP' ||
            item.variableType === 'NDEBPR' ||
            isPrNumberMeasure(item)) &&
          isPrOrMrInstallCode &&
          type === 'do'
        ) {
          prNombre.push(item);
        } else if (
          (item.variableType === 'VDEBTP' ||
            item.variableType === 'VDEBPR' ||
            isPrVolumeMeasure(item)) &&
          isPrOrMrInstallCode &&
          type === 'do'
        ) {        
          prVolume = item;
        }

        //PR
        else if (isPrTimeMeasure(item) && type === 'pr') {
          prTemps.push(checkLimits(item, 'prTemps'));
        } else if (isPrNumberMeasure(item) && type === 'pr') {
          prNombre.push(checkLimits(item, 'prNombre'));
        } else if (isPrVolumeMeasure(item) && type === 'pr') {
          prVolume = item;
        }

        //MR
        else if (
          (item.variableType === 'VRESEAUMR' || item.variableType === 'VRESEAU') &&
          type === 'pr'
        ) {
          mrVolume = item;
        } else if (
          (item.variableType === 'MNIVEAUMR' || item.variableType === 'MNIVEAURESEAU') &&
          type === 'pr'
        ) {
          mrNiveau = item;
        } else if (item.variableType === 'TAUXREMPLISSAGE' && type === 'pr') {
          mrTaux = item;
        }
      });

      if (type === 'do' && getPluvio.status === 'fulfilled') {
        pluvioList = getPluvio.value.data;
      } else {
        pluvioList = getMeasures.value.data.pluviometries;
      }

    }

    return {
      data: {
        doTemps,
        doNombre,
        doVolume,
        prTemps,
        prNombre,
        prVolume,
        mrVolume,
        mrNiveau,
        mrTaux,
        pluvioList
      },
    };
  } catch(error) {
    dataService2.setError(true);
    return {
      data: {
        doTemps,
        doNombre,
        doVolume,
        prTemps,
        prNombre,
        prVolume,
        mrVolume,
        mrNiveau,
        mrTaux,
        pluvioList
      }
    }
  }
};

// récupérer les données DO et PR pour les graphes
export const getLevelsPr = async (code: any, startDate: any, endDate: any) => {
  let prLevels: any = [];
  let allMeasures, allTresholds;
  try {
    const responseLevelsApi = LevelsPrApi.getLevels(code, startDate, endDate);
    const responseSeuils = SeuilsApi.getSeuilsOverflow(code);
    const [levelsMeasures, tresholdsMeasures] = await Promise.allSettled([responseLevelsApi, responseSeuils]);

    if(levelsMeasures.status === 'fulfilled') {
      allMeasures = [
        levelsMeasures.value.data.map((d) => ({
          time: d.recordDate,
          value: parseFloat(d.maxValue),
        })),
        levelsMeasures.value.data.map((d) => ({
          time: d.recordDate,
          value: parseFloat(d.avgValue),
        })),
        levelsMeasures.value.data.map((d) => ({
          time: d.recordDate,
          value: parseFloat(d.minValue),
        }))
      ];
    }

    if (tresholdsMeasures.status === 'fulfilled') {
      allTresholds = tresholdsMeasures.value.data !== undefined ? [
        [
          tresholdsMeasures.value.data.alert !== null ? [
            {
              time: startDate,
              value: tresholdsMeasures.value.data.alert,
            },
            {
              time: endDate,
              value: tresholdsMeasures.value.data.alert,
            },
          ] : [],
          tresholdsMeasures.value.data.vigilance !== null ? [
            {
              time: startDate,
              value: tresholdsMeasures.value.data.vigilance,
            },
            {
              time: endDate,
              value: tresholdsMeasures.value.data.vigilance,
            },
          ] : [],
        ],
      ] : [];
    }

    // PR levels
    prLevels = {
      measures: [
        allMeasures !== undefined ? allMeasures : [],
      ],
      tresholds: 
        allTresholds,
    };
    return prLevels;
    
  } catch (error) {
    return[];
  }
};

//changer le format de la date pour l'envoi à l'api
export const reformatDate = (date: any) => {
  let finalMonth: string, finalDay: string, finalDate: string | null;
  if (date) {
    if (date.month < 10) {
      finalMonth = '0' + date.month;
    } else {
      finalMonth = date.month;
    }
    if (date.day < 10) {
      finalDay = '0' + date.day;
    } else {
      finalDay = date.day;
    }
    finalDate = date.year + '-' + finalMonth + '-' + finalDay;
  } else {
    finalDate = null;
  }
  return finalDate;
};

export const formatDate = (pDate) => {
  // convert french date format
  const dateToSplit: string = pDate;
  const dateSplited = dateToSplit.split('/');
  // eng format
  let date = dateSplited[2] + '-' + dateSplited[1] + '-' + dateSplited[0];
  return date;
};

// changer le format de la date pour le composant front
export const inputTextDate = (date: any) => {
  let month: string, day: string, goodate: string;
  if (date) {
    if (date.month < 10) {
      month = '0' + date.month;
    } else {
      month = date.month;
    }
    if (date.day < 10) {
      day = '0' + date.day;
    } else {
      day = date.day;
    }
    goodate = day + '/' + month + '/' + date.year;
  } else {
    goodate = '';
  }
  return goodate;
};

// function to transform date format to object format
export function transformDate(dateString) {
  const dateParts = dateString.split('/');
  const day = parseInt(dateParts[0]);
  const month = parseInt(dateParts[1]);
  const year = parseInt(dateParts[2]);

  return { day, month, year };
}

//caculer nombre d'année entre une date donnée en paramètre et la date du jour
export const getAge = (date: any) => {
  const today = new Date();
  const startDate = new Date(date);
  let age = today.getFullYear() - startDate.getFullYear();
  const m = today.getMonth() - startDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < startDate.getDate())) {
    age--;
  }
  return age;
};

export const PageStyles = createGlobalStyle`
.sds-reset-style{
  .global-container{
    margin-left: 5%;
    margin-top: 1%;
  } 
}
`;

// manage zooms for graphics
export const showHideGraphics = (pGraphicToGrow: string, pMode: string, pChartKeys?: string[]) => {
  const displays = {};
  (pChartKeys ?? [
    'dataTemps-chart',
    'dataNombre-chart',
    'dataVolume-chart',
    'dataLevels-chart',
  ]).forEach((key) => {
    displays[key] = 'block';
  });
  if (pMode === 'hide') {
    // show graphic you want to zoom in
    Object.keys(displays).forEach((key) => {
      if (key === pGraphicToGrow) {
        displays[key] = 'block';
      } else {
        displays[key] = 'none';
      }
    });
  } else {
    // show all graphics
    Object.keys(displays).forEach((key) => {
      displays[key] = 'block';
    });
  }
  return displays;
};

export const getDataTresholds = (
  pInstallType: string,
  pDataType: string,
  pData: any,
) => {
  let dataToShow = [];
  if (pInstallType === 'DO' && pDataType === 'time') {
    dataToShow = pData?.doTemps?.tresholds;
  } else if (
    (pInstallType === 'PR' || pInstallType === 'TP') &&
    pDataType === 'time'
  ) {
    dataToShow = pData?.prTemps[0]?.tresholds;
  } else if (pInstallType === 'DO' && pDataType === 'nb') {
    dataToShow = pData?.doNombre?.tresholds;
  } else if (pInstallType === 'PR' && pDataType === 'nb') {
    dataToShow = pData?.prNombre?.tresholds;
  } else if (pInstallType === 'PR' && pDataType === 'volume') {
    dataToShow = pData?.prVolume?.tresholds;
  } else if (pInstallType === 'TP' && pDataType === 'volume') {
    dataToShow = pData?.prVolume?.tresholds;
  } else if (pInstallType === 'MR' && pDataType === 'volume') {
    dataToShow = pData?.mrVolume?.tresholds;
  } else if (pDataType === 'levels') {
    dataToShow = pData?.tresholds;
  }

  if (dataToShow === undefined) {
    dataToShow = [];
  }
  return dataToShow;
};

// get specific data for graphic
export const getDataMeasures = (
  pInstallType: string,
  pDataType: string,
  pData: any,
) => {  
  let dataToShow = [];
  if (pInstallType === 'DO' && pDataType === 'time') {
    dataToShow = pData?.doTemps?.measures;
  } else if (pDataType === 'levels') {
    dataToShow = pData?.measures[0];
  } else if (
    (pInstallType === 'PR' || pInstallType === 'TP') &&
    pDataType === 'time'
  ) {
    dataToShow = pData?.prTemps[0]?.measures;
  } else if (pInstallType === 'DO' && pDataType === 'nb') {
    dataToShow = pData?.doNombre?.measures;
  } else if (
    (pInstallType === 'PR' || pInstallType === 'TP') &&
    pDataType === 'nb'
  ) {
    dataToShow = pData?.prNombre[0]?.measures;
  } else if (pInstallType === '' && pDataType === 'pluvio') {
    dataToShow = pData?.pluvioList;
  } else if (pInstallType === '' && pDataType === 'piezo') {
    dataToShow = pData;
  } else if (pInstallType === 'DO' && pDataType === 'volume') {    
    dataToShow = pData?.doVolume?.measures || pData?.prVolume.measures;
  } else if (pInstallType === 'PR' && pDataType === 'volume') {
    dataToShow = pData?.prVolume.measures;
  } else if (pInstallType === 'TP' && pDataType === 'volume') {
    dataToShow = pData?.prVolume.measures;
  } else if (pInstallType === 'MR' && pDataType === 'volume') {
    dataToShow = pData?.mrVolume?.measures;
  } else if (pInstallType === 'MR' && pDataType === 'niveau') {
    dataToShow = pData?.mrNiveau?.measures;
  } else if (pInstallType === 'MR' && pDataType === 'taux') {
    dataToShow = pData?.mrTaux?.measures;
  }

  // if no data found
  if (dataToShow === undefined) {
    dataToShow = [];
  }
  return dataToShow;
};

export const datesFormatedForRequest = (pStartDate: any, pEndDate: any) => {
  const dates = { start: pStartDate, end: pEndDate };
  const dataDates = dateFormatedForRequest(dates, '');
  const pluvioDates = dateFormatedForRequest(dates, 'pluvio');
  return { dataDates: dataDates, pluvioDates: pluvioDates };
};

export const controlPiezoList = (pPiezoList: any[], pPiezoCode: string) => {
  let piezoSelected = [];
  if(pPiezoList.filter((p) => p.code === pPiezoCode)[0] !== undefined){
    piezoSelected = pPiezoList.filter((p) => p.code === pPiezoCode)[0].measures;
  }
  return piezoSelected;
};

export const loaderForGraphics = (pWidth: string, pHeight: string, pClassName: string) => {
  return (
    <div style={{
      width: pWidth,
      height: pHeight,
      textAlign: 'center',
      backgroundColor: 'white',
      display: 'grid',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '10px',
      borderRadius: '15px',
      boxShadow: '0 14px 14px 3px rgba(18, 26, 49, 0.05)',
    }}>
      <span className={pClassName}/>
    </div>
  );
};

export const piezometersDropdownlistComponent = (
  pPiezoOptions: any[],
  pPiezoSelected: string,
  setter: Function,
  errorCss: object,
  isDataFound: any
) => {
  return (
    <Container className="dropdownlist-container" style={{ position: 'relative', marginTop: '8px' }}>
      <div className="piezo-main-line" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
        <Typography variant="body1" style={{ marginRight: 0 }}>
          Piézomètres :
        </Typography>

        {pPiezoOptions === null ? (
          <CircularProgress size={24} />
        ) : pPiezoOptions.length === 0 ? (
          <span style={errorCss}>Pas de données !</span>
        ) : (
          <FormControl size="small" variant="outlined" style={{ minWidth: 220 }}>
            <Select
              value={pPiezoSelected || ''}
              displayEmpty
              renderValue={(selected: any) => {
                if (!selected) {
                  return 'Choisir un piézomètre';
                }
                return (
                  pPiezoOptions.find((opt: any) => opt.value === selected)?.label ||
                  selected
                );
              }}
              onChange={(e) => setter(e.target.value)}
              MenuProps={{
                PaperProps: { style: { maxHeight: 200, zIndex: 1300 } },
              }}
            >
              {pPiezoOptions.map((opt: any) => (
                <MenuItem key={opt.id} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </div>

      {(pPiezoOptions !== null && isDataFound === true) && (
        <span style={{ ...errorCss, marginTop: '6px', display: 'inline-block' }}>
          Pas de mesures !
        </span>
      )}
    </Container>
  );
};

export const loaderData = (pClassName: string) => {
  return (
    <div>
      <span className={pClassName}/>
    </div>
  );
};

export const anyMeasuresFindForPiezometrySelected = (piezoMeasures: any[], pPiezoCode: string) => {
  let noMeasures = false;
  const result = piezoMeasures.find((piezo: any) => piezo.code === pPiezoCode)?.measures.length === 0;
  if (result === true) {
    noMeasures = true;
  }
  return noMeasures;
};

export const radioButtonComponent = (pShowFilters: boolean, pDataToAdd: any[], setter: Function, errorCss: object) => {
  const Styles = createGlobalStyle`.sds-reset-style{
    .loaderPiezo {
      width: 28px;
      height: 28px;
      border: 5px solid #FFF;
      border-bottom-color: #243977;
      border-radius: 50%;
      display: inline-block;
      box-sizing: border-box;
      animation: rotation 1s linear infinite;
      }

      @keyframes rotation {
      0% {
          transform: rotate(0deg);
      }
      100% {
          transform: rotate(360deg);
      }
    }
    .mesure-radiolist{
      flex-direction: row !important;
      justify-content: space-evenly;
      width: 35vh;
      align-items: baseline;
    }
    .sds-m-radio-list .radio-item .radio-item-label{
      margin-left: 5px;
    }
    .sds-radio-item {
      display: contents;
    } 
  }`;
  return (
    <>
    <Styles/>
    <div style={{ display: 'flex', flexDirection: 'row'}}>
    {pShowFilters === true && 
      <RadioList
        className='mesure-radiolist'
        selected={3}
        onChange={(v: any) => {
          setter(v);
        }}
        values={pDataToAdd}
      />}
    </div>
    {(pShowFilters === false && pDataToAdd.length === 0) && 
      <span style={errorCss}>
        Pas de données pluviométriques et piézométriques !
      </span>}
    {pShowFilters === false && pDataToAdd.length !== 0 && loaderData('loaderPiezo')}
    </>
  );
};

export const savePiezoParameter = async (
  pPiezoSelected: string,
  pPiezoParameter: any,
  pSetPiezoParameter: Function,
  pToastSucess: React.MutableRefObject<any>,
  pToastError: React.MutableRefObject<any>,
) => {
  try {
    const response = await PiezometryApi.updateParameter({
      id: pPiezoParameter.id,
      mainInstallCode: pPiezoParameter.mainInstallCode,
      bssId: pPiezoSelected
    });
    if (response.status === 200) {
      pToastSucess.current?.show({
        severity: 'success',
        summary: 'Succès',
        detail: 'Piézomètre paramétré avec succès.',
        life: 5000,
      });
      pSetPiezoParameter({ bssId: response.data.bssId, mainInstallCode: response.data.mainInstallCode, id: response.data.id });
    }
  } catch (e) {
    console.log(e);
    pToastError.current?.show({
      severity: 'error',
      summary: 'Erreur',
      detail: "L'enregistrement a échoué. Veuillez réessayer.",
      life: 5000,
    });
  }
};

export const handleActiveButton = (pIndex: number, pTabs: any[], setter: Function) => {
  const newStates = pTabs.map((buttonProps, i) => {
    return {
      ...buttonProps,
      active: i === pIndex ? true : false,
    };
  });
  setter(newStates);
  
  // Force a refresh of the active tab to ensure data consistency
  setTimeout(() => {
    const activeTab = newStates.find(tab => tab.active);
    if (activeTab && activeTab.trigger) {
      activeTab.trigger();
    }
  }, 50);
};

export const renderSwitchButtons = (pTabs: any[], pSetter: Function) => {
  const Styles = createGlobalStyle`.sds-reset-style{
    .button-container {
      display: flex;
      flex-direction: row;
      justify-content: center;
      border-radius: 22px;
      .active {
        font-size: 14px;
        line-height: 22px;
        text-align: center;
        background-color: #008BD2;
        border-radius: 25px;
        cursor: pointer;
        padding: 10px 20px;
      }
      .tab-button {
        font-size: 14px;
        line-height: 22px;
        text-align: center;
        border-radius: 25px;
        cursor: pointer;
        padding: 10px 20px;
        background-color: rgb(237, 242, 250);
      }
    }
  }`;
  return (
    <>
    <Styles/>
    <div className='button-container'>
      {pTabs.map((tab: TabProps) => (
        <Button
          className={tab.active === true ? 'active' : 'tab-button'}
          mode='basic'
          key={uuidv4()}
          onClick={() => handleActiveButton(tab.id, pTabs, pSetter)}
        >
          <span style={{ fontSize: '14px', color: tab.active === true ? '#fff' : '#232323', fontWeight: 'bolder' }}>{tab.label}</span>
        </Button>
      ))}
    </div>
    </>
  );
};